import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import authService from './api-authorization/AuthorizeService';
import DriverTabData from './DriverTab';

interface DriverJobsTeam {
    loading: boolean;
    errors: any;
    truckId: number;
    driver: string;
    teamLead: string;
    team: GenericList[];
}

interface GenericList {
    id: number;
    name: string;
}

interface INameToValueMap {
    [key: string]: any;
}

export class DriverJobsTeamData extends React.Component<RouteComponentProps<{}>, DriverJobsTeam> {
    constructor(props: any) {
        super(props);

        this.state = {
            loading: true,
            errors: {},
            truckId: 0,
            driver: "",
            teamLead: "",
            team: []
        };
    }

    componentDidMount() {
        window.scrollTo(0, 0);

        //see if there is a truck set
        let userParams: INameToValueMap = {};
        userParams["truckId"] = -1;
        userParams = this.props.match.params;
        let truckId = userParams["truckId"];
        if (!truckId) { truckId = -1; }

        this.getData(truckId);
    }

    async getData(truckId: number) {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        axios.get('api/Job/GetTruckTeam?SubId=' + user.sub + "&TruckId=" + truckId, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            this.setState({ truckId: res.data.vehicleId, driver: res.data.driver, teamLead: res.data.teamLead, team: res.data.team, loading: false });
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    back = (e: any) => {
        e.preventDefault();
        this.props.history.push("/driverjobs");
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderDetails();

        return <div>
            {contents}
        </div>;
    }

    renderDetails = () => {
        let team = this.state.team;
        var driverTabsMobile = <DriverTabData tab="driverjobs" truckId={this.state.truckId} />

        return (
            <div>
                <div className="mobileFont marginTop70 marginBottom10">
                    <h2 className="marginBottom10">Truck Team</h2>
                    <span className="label-mobile--inline margin5">{this.state.teamLead}</span>
                    <hr></hr>
                    <span className="label-mobile--inline margin5">{this.state.driver}</span>
                    <hr></hr>
                    <div className={this.state.truckId <= 0 ? "hidden" : ""}>
                        {team.map((member, index) =>
                            <span key={member.id} className="label-mobile--inline margin5">{member.name}</span>
                        )}
                        <hr></hr>
                    </div>
                </div>
                <div>
                    {driverTabsMobile}
                </div>
            </div>
        );

    }
}
